<template>
    <!-- Start Pricing Options Section -->
    <section class="pricing-options text-center">
        <h1>Pricing Options</h1>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
        <!-- Start Container -->
        <div class="container">
            <!-- Start Row -->
            <div class="row">
                <!-- Start Column -->
                <div
                    class="col-md-4"
                    v-for="pricing_option_info in pricing_options_info"
                    :key="pricing_option_info.id"
                >
                    <!-- Start Card Component (From Bootstrap) "Hosting Details" -->
                    <div :class="[{'professional-hosting': pricing_option_info.id == 2}, 'card' , 'hosting-details']">
                        <!-- Start Hosting Caption -->
                        <div class="card-body hosting-caption">
                            <h4 class="card-title hosting-type">
                                {{ pricing_option_info.hosting_details.hosting_caption.hosting_type }}
                            </h4>
                            <!-- Start Hosting Price -->
                            <div class="hosting-price">
                                <span>
                                    $<span class="usd">{{ pricing_option_info.hosting_details.hosting_caption.hosting_price }}</span>
                                </span>
                            </div>
                            <!-- End Hosting Price -->
                            <h6 class="payment-method">
                                {{ pricing_option_info.hosting_details.hosting_caption.payment_method }}
                            </h6>
                            <p class="hosting-popular" v-if="pricing_option_info.id == 2">Our Most Popular</p>
                        </div>
                        <!-- End Hosting Caption -->
                        <!-- Start Hosting Type Features -->
                        <ul class="list-group list-group-flush hosting-type-features">
                            <li class="list-group-item">
                                {{
                                    pricing_option_info.hosting_details.hosting_type_features.websites_number === "1" ?

                                        pricing_option_info.hosting_details.hosting_type_features.websites_number + " Website":
                                        
                                        pricing_option_info.hosting_details.hosting_type_features.websites_number
                                }}
                            </li>
                            <li class="list-group-item">
                                {{pricing_option_info.hosting_details.hosting_type_features.space}}
                                {{ pricing_option_info.hosting_details.hosting_caption.hosting_type === "Free Hosting" ? "MB": "GB"}} Disk Space
                            </li>
                            <li class="list-group-item">
                                {{pricing_option_info.hosting_details.hosting_type_features.bandwidth}}
                            </li>
                            <li class="list-group-item">
                                {{pricing_option_info.hosting_details.hosting_type_features.users_account_number}} User Account
                            </li>
                        </ul>
                        <!-- End Hosting Type Features -->
                    </div>
                    <!-- End Card Component (From Bootstrap) "Hosting Details" -->
                </div>
                <!-- End Column -->
            </div>
            <!-- End Row -->
        </div>
        <!-- End Container -->
    </section>
    <!-- End Pricing Options Section -->
</template>

<style scoped lang="scss">

    .pricing-options{
        padding: var(--main-padding);
        background-color: var(--second-background);
        > h1 {
            margin-bottom: 50px;
            position: relative;
            &::after{
                content: '';
                position: absolute;
                bottom: -25px;
                left: calc(50% - 50px);
                width: 100px;
                height: 3px;
                background-color: var(--main-color)
            }
        }
        > p{
            color: var(--second-color);
            margin-bottom: 100px;
            @media(max-width: 767px){
                margin-bottom: 30px
            }
        }
        .hosting-details{
            .hosting-caption{
                background-color: var(--main-background);
                color: #FFF;
                border-bottom: 5px solid var(--main-color);
                &.card-body{
                    padding: 0
                }

                .hosting-type{
                    border-bottom: 1px solid #FFF;
                    padding: {
                        top: 10px;
                        bottom: 10px
                    };
                }

                .hosting-price{
                    padding: {
                        top: 20px;
                        bottom: 20px
                    };
                    span{
                        font-size: 30px;
                        .usd{
                            font-size: 60px
                        }
                    }
                }

                .payment-method{
                    color: var(--second-background);
                    margin-bottom: 20px
                }

                .hosting-popular{
                    background-color: var(--main-color)
                }

            }

            &.professional-hosting{
                margin-top: -50px;
                .hosting-caption{
                    border-bottom: none;
                    .hosting-popular{
                        margin-bottom: 0;
                        padding: {
                            top: 10px;
                            bottom: 10px
                        }
                    }
                }
                @media(max-width: 767px){
                    margin: {
                        top: 40px;
                        bottom: 40px
                    }
                }
            }

            &:last-child{
                margin-bottom: 40px
            }

        }
    }

</style>

<script>

import {pricing_options_info} from "../../assets/jsonData/index.json"

export default {

    name: "PricingOptions",

    data: function () {

        return {

            pricing_options_info

        }

    }

}

</script>